import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  InputBase,
  Pagination,
  IconButton,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomText, { textStyles } from "../../../../components/CustomText";
import StatusDropdown from "../../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import emptypayment from "../../../../assets/emptypayment.png";
import TruncatedCell from "../../../../components/TruncatedCell";
const headerStyle = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
};

const dataStyle = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
   whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const usd = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(Number(n || 0));

const WorkerReimbursements = ({ workerId }) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 5;

  const fetchData = async (page = 1, q = "", isInitial = false) => {
    try {
      isInitial ? setInitialLoading(true) : setTableLoading(true);
const url = `${BASE_URL}/company-admin/expenses?worker=${workerId}&q=${q}&page=${page}&limit=${pageSize}&sort=-created_at`;


      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      const json = await res.json();

      if (!json.error && json.data) {
        const mapped = json.data.map((item) => ({
          id: item.id,
          workerName: item.worker?.name || "-",
          amount: item.amount,
          date: new Date(item.date_of_expense).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          receipt: item.receipt_url,
          status: item.status,
          description: item.description || "-",
        }));
console.log("reimbursement data",mapped)
        setRows(mapped);
        setTotalPages(json.pagination?.pages || 1);
      }
    } catch (err) {
      console.error("Reimbursement fetch error", err);
    } finally {
      isInitial ? setInitialLoading(false) : setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, "", true);
    // eslint-disable-next-line
  }, [workerId]);

  useEffect(() => {
    if (!initialLoading) {
      fetchData(currentPage, searchTerm, false);
    }
    // eslint-disable-next-line
  }, [currentPage, searchTerm]);

  return (
    <Box sx={{ backgroundColor: "#fff", borderRadius: 2, border: "2px solid #091E4224", py: 2 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 2,
          pb: 2,
          borderBottom: "2px solid #091E4224",
        }}
      >

            <Box
                sx={{
                  pb: 2,
                  px: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap:2,
                }}
              >
            
        <CustomText      sx={{
                      ...textStyles.h1,
                      fontWeight: 600,
                      fontSize: "18px",
                      color: "#003149",
                      textAlign: "left",
                    }}>
          {t("reimbursements")}
        </CustomText>

        {tableLoading && <CircularProgress size={20} />}
</Box>
        <Box
          sx={{
            px: 1,
            border: "2px solid #091E4224",
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            minWidth: 250,
          }}
        >
          <InputBase
            placeholder={t("search")}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            sx={{ fontSize: 14, width: "100%" }}
          />
          <SearchIcon sx={{ color: "#888" }} />
        </Box>
      </Box>

      {/* Content */}
      {initialLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Table>
            <TableHead>
              <TableRow>
            <TableCell sx={headerStyle}>{t("id")}</TableCell>
<TableCell sx={headerStyle}>{t("employee")}</TableCell>
<TableCell sx={headerStyle}>{t("amount")}</TableCell>
<TableCell sx={headerStyle}>{t("date")}</TableCell>
<TableCell sx={headerStyle}>{t("proof")}</TableCell>
<TableCell sx={headerStyle}>{t("status")}</TableCell>
<TableCell sx={headerStyle}>{t("comments")}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.length ? (
                rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell sx={dataStyle}>{row.id}</TableCell>
                    <TableCell sx={dataStyle}>{row.workerName}</TableCell>
                    <TableCell sx={dataStyle}>{usd(row.amount)}</TableCell>
                    <TableCell sx={dataStyle}>{row.date}</TableCell>
                    <TableCell>
                      {row.receipt ? (
                        <IconButton onClick={() => window.open(row.receipt, "_blank")}>
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      <StatusDropdown currentStatus={row.status} />
                    </TableCell>
                    <TableCell sx={dataStyle}>
                        {/* {row.description} */}
                      <TruncatedCell text={row.description} />
                        

                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <img src={emptypayment} width={180} alt="empty" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, v) => setCurrentPage(v)}
                shape="rounded"
          color="primary"
          size="small"
                sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: 13,
                  fontWeight: 500,
                },
                "& .Mui-selected": {
                  backgroundColor: "#E9F3FF",
                  color: "#006EC2",
                },
              }}
          />
        </>
      )}
    </Box>
  );
};

export default WorkerReimbursements;
